let tel_number = null
let code = null
let isAuthenticated = !!localStorage.getItem('access')
export default {
    tel_number,
    code,
    isAuthenticated
}